import type { RmsReport } from '@/view/rms/types';
import type { RmsReportDto } from './api.types';

export const transformReport = (dto: RmsReportDto): RmsReport => ({
  ...dto,
  createdAt: new Date(dto.createdAt),
  updatedAt: new Date(dto.updatedAt),
});

export const transformReports = (dtos: RmsReportDto[]): RmsReport[] =>
  dtos.map(transformReport);
